<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <!-- <company-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" /> -->
    <!-- <div class="modify-img flex justify-between mt-5"> -->

    <!-- </div> -->
    <vs-table pagination :max-items="itemsPerPage" search :data="companies">
      <!-- <div slot="header" class="flex items-center flex-grow justify-between">
        <div class="flex items-center data-list-btn-container">Compa</div>
      </div>-->

      <template slot="thead">
        <vs-th>TAXIPOINT ID</vs-th>
        <vs-th>Ghost Company ID</vs-th>
        <vs-th>Logo</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="name">Wallet Amount</vs-th>
        <vs-th sort-key="name">Charity Collected</vs-th>
        <vs-th>Telephone</vs-th>
        <vs-th>Actions</vs-th>
        <vs-th>Configuration</vs-th>
        <!-- <vs-th>Action</vs-th> -->
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.id }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.api_company_id }}
              </p>
            </vs-td>
            <vs-td class="img-container">
              <img
                :src="
                  tr.logo_url ? imageRoute + '/' + tr.logo_url : tr.logo_url
                "
                class="product-img"
              />
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                &pound;&nbsp;{{ tr.wallet_amount }}
              </p>
            </vs-td>
            <vs-td>
              <div class="flex justify-between">
                <p class="product-name font-medium truncate">
                  &pound;&nbsp;
                  {{ parseFloat(tr.charity_collected).toFixed(2) }}
                </p>
                <vs-button
                  size="small"
                  radius
                  type="flat"
                  icon="icon-download"
                  icon-pack="feather"
                  @click="setCompanyForCharity(tr.id)"
                />
              </div>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.telephone }}
              </p>
            </vs-td>
            <vs-td class="vx-col w-full flex">
              <input
                type="file"
                class="hidden"
                :ref="'updateImgInput' + tr.id"
                accept="image/*"
                :id="tr.id"
                @change="handleClick"
              />
              <vs-button
                type="filled"
                icon-pack="feather"
                icon="icon-camera"
                size="small"
                @click="updateImageClick('updateImgInput' + tr.id)"
                >Update logo</vs-button
              >
            </vs-td>
            <!-- <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
            </vs-td>-->
            <vs-td>
              <div class="vx-col w-full flex mb-8" style="grid-gap: 5px">
                <vs-button
                  @click="setSelectedCompany(indextr, tr)"
                  size="small"
                  color="warning"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-settings"
                  >Settings</vs-button
                >
                <vs-button
                  @click="setSelectedCompanyForCharity(indextr, tr)"
                  size="small"
                  color="success"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-gift"
                  >Charity</vs-button
                >
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-prompt
      title="Company Settings"
      @accept="acceptAlert"
      accept-text="Save"
      :active.sync="companySettingPrompt"
    >
      <h5 class="text-primary mb-3 flex justify-center">
        Enter capabilities and their booking fee
      </h5>
      <div
        v-for="(field, key) in capability_fields"
        :key="key"
        class="mb-2 input-group input-group"
      >
        <div class="flex items-start" style="grid-gap: 3px">
          <vs-input
            label-placeholder="Capability"
            v-model="field.key"
            :disabled="field.key == 'default'"
          />

          <vs-input
            label-placeholder="Booking fee"
            type="text"
            v-model="field.value"
          />
          <vs-button
            class="mt-5"
            color="success"
            radius
            icon="add"
            type="filled"
            @click="AddField"
          >
          </vs-button>

          <vs-button
            class="mt-5"
            :disabled="field.key == 'default'"
            color="danger"
            radius
            icon="cancel"
            type="filled"
            @click="RemoveField(key)"
          ></vs-button>
        </div>
      </div>
      <!-- </div> -->
    </vs-prompt>

    <vs-prompt
      title="Charity Details"
      @accept="saveCharity"
      accept-text="Save"
      :active.sync="charityPrompt"
    >
      <div class="flex justify-between">
        <h5 class="text-primary mb-2">
          Status
        </h5>
        <vs-switch color="success" v-model="charityDetails.is_enabled">
          <span slot="on">Enabled</span>
          <span slot="off">Disabled</span>
        </vs-switch>
      </div>
      <div>
        <label class="text-sm text-primary">Title</label>
        <vs-input
          class="w-full mb-2"
          placeholder="Title"
          v-model="charityDetails.title"
        />

        <label class="text-sm text-primary mt-9">Description</label>
        <vs-textarea
          class="w-full "
          height="200px"
          placeholder="Enter description here...."
          v-model="charityDetails.description"
        />
      </div>

      <!-- </div> -->
    </vs-prompt>

    <vs-prompt
      title="Charity Details"
      :active.sync="charityExcelPopup"
      :acceptText="'Download'"
      @accept="downloadExcel"
    >
      <div class="con-exemple-prompt">
        <label class="text-sm font-bold ml-1">Start date: *</label>
        <datepicker
          name="start-date"
          class="mb-4"
          label="Name"
          placeholder="From Date"
          v-model="startDate"
        >
        </datepicker>
        <label class="text-sm font-bold ml-1">End date: *</label>
        <datepicker
          :calendar-button="true"
          :bootstrap-styling="true"
          icon-pack="fa"
          val-icon-pack="fa"
          calendar-button-icon="eye"
          name="end-date"
          class="mb-4"
          label="Name"
          placeholder="To Date"
          v-model="endDate"
          icon-after="true"
          :disabled="!startDate"
        >
        </datepicker>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { MAIN_DOMAIN } from "@/environment";
import moment from "moment";
  import Datepicker from "vuejs-datepicker";

import {
  _list,
  _upload_logo,
  _update_settings,
  _update_charity,
  _charity_details
} from "@/services/Company";

export default {
  components: {
    Datepicker
  },
  watch: {
    startDate() {
      this.endDate = ''
    }
  },
  computed: {
    validForm() {
        return this.startDate != '' && this.endDate != '' && (Date.parse(this.endDate) - Date.parse(this.startDate)) >= 0 && !this.errors.has('event-url');
    },
  },
  data() {
    return {
      charityExcelPopup: false,
      startDate: "",
      endDate: "",
      companyId: -1,

      selected: [],
      // companies: [],
      itemsPerPage: 10,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      companies: [],
      imageRoute: MAIN_DOMAIN + "/uploads",
      companySettingPrompt: false,
      currentIdx: -1,
      currentCompany: null,
      capability_fields: [{}],
      charityPrompt: false,
      enableCharity: false,
      charityDetails: {
        title: null,
        description: null,
        is_enabled: null
      }
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },

    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.companies.length;
    }
  },
  methods: {
    updateImageClick(e) {
      this.$refs[e][0].click();
    },
    AddField() {
      this.$emit("dataFeature", this.capability_fields);
      this.capability_fields.push({ key: null, value: null });
    },
    RemoveField(key) {
      this.capability_fields.splice(key, 1);
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = e => {
          console.log(e.target.result);
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    setSelectedCompany(idx, val) {
      console.log(idx);
      console.log(val);
      this.currentCompany = val;
      this.currentIdx = idx;
      this.companySettingPrompt = true;
      this.capability_fields = JSON.parse(JSON.stringify(val.settings));
    },

    setSelectedCompanyForCharity(idx, val) {
      this.currentCompany = val;
      this.currentIdx = idx;
      this.charityPrompt = true;
      if (val.charity_detail) {
        this.charityDetails = val.charity_detail;
      } else {
        this.charityDetails = {
          title: null,
          description: null,
          is_enabled: 0
        };
      }
    },
    setCompanyForCharity(id)
    {
      this.companyId = id
      this.charityExcelPopup = true
    },

    acceptAlert() {
      var settings = this.capability_fields;
      var realSettings = settings.filter(function(e) {
        return e.key != null && e.value != null;
      });
      console.log(this.companies[this.currentIdx]);
      _update_settings(this.currentCompany.id, {
        settings: realSettings
      })
        .then(res => {

          console.log(this.currentIdx);
          this.companies[this.currentIdx] = res.data.obj.company;

      console.log(this.companies[this.currentIdx]);

          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Booking fee updated successfully"
          });
        })
        .catch(err => {});
    },
    saveCharity() {
      _update_charity(this.currentCompany.id, this.charityDetails)
        .then(
          res => {
            this.companies[this.currentIdx] = res.data.obj.company;
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Company charity updated successfully"
            });
          },
          error => {
            this.$vs.notify({
              color: "danger",
              title: "failed operation",
              text: error.message
            });
          }
        )
        .catch(err => {
          this.$vs.notify({
            color: "danger",
            title: "Catch failed",
            text: err.message
          });
        });
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0];
      if (!rawFile) return;
      this.uploadFile(e.target.id, rawFile);
    },
    uploadFile(company_id, rawFile) {
      let formData = new FormData();
      formData.append("photo", rawFile);
      this.$vs.loading();
      _upload_logo(company_id, formData)
        .then(
          response => {
            this.$vs.loading.close();
            let obj = this.companies.find(obj => obj.id == company_id);

            obj.logo_url = response.data.obj.filename;
            this.$vs.notify({
              title: response.data.responseTitle,
              text: response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-check-circle",
              color: "success"
            });
          },
          error => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger"
            });
          }
        )
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger"
          });
        });
      this.$refs["fileInput"].value = null; // fix can't select the same excel
    },
     downloadExcel() {
      this.$vs.loading();

      let df = moment(this.startDate).format('YYYY-MM-DD');
      let dt = moment(this.endDate).format('YYYY-MM-DD');
      const data = {
        from_date: df,
        to_date: dt
      };

      _charity_details(this.companyId, data).then((res) => {
        this.clearFields();
            import("@/vendor/Export2Excel").then((excel) => {
            this.$vs.loading.close();

            const list = res.data.obj.data;
            const headerVal = [
                  "Booking ID",
                  "Customer Name",
                  "Charity Amount",
                  "Paid on"
            ];
            const data = this.formatJson(headerVal, list);
            excel.export_json_to_excel({
              header: [
                  "Booking ID",
                  "Customer Name",
                  "Charity Amount",
                  "Paid on"
            ],
              data,
              filename: moment(),
              autoWidth: true,
              bookType: "xls",
            });

          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j == "Booking ID") return v.api_booking_id;
          else if (j == "Customer Name") return v.customer_name;
          else if (j == "Charity Amount") return v.amount+ " £ ";
          else if (j == "Paid on") return v.created_at;
          else return v[j];
        })
      );
    },
    clearFields() {
      this.startDate = this.endDate  = "";
    },
  },
  created() {
    this.$vs.loading();
    _list()
      .then(response => {
        this.$vs.loading.close();
        this.companies = response.data.obj.list;
      })
      .catch(error => {
        this.$vs.loading.close();
        this.$vs.notify({
          title: error.response.data.responseTitle,
          text: error.response.data.responseMessage,
          iconPack: "feather",
          icon: "icon-cross-circle",
          color: "danger"
        });
      });
  },
  mounted() {
    this.isMounted = true;
    //fire.$on('reset', this.resetField);
  }
};
</script>

<style lang="scss">
.product-img {
  height: 50px;
  width: 50px;
}
#company-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
